import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export default class MensagemAbertura extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayBasic: false,
            position: 'center'
        };

        this.onClick = this.onClick.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    componentDidMount(){
        this.carregaModal();
    }

    onClick(name, position) {
        let state = {
            [`${name}`]: true
        };

        if (position) {
            state = {
                ...state,
                position
            }
        }

        this.setState(state);
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    carregaModal = () => {
        this.setState({
            displayBasic: true
        });
    }


    renderFooter(name) {
        return (
            <div>
                {/*<Button label="No" icon="pi pi-times" onClick={() => this.onHide(name)} className="p-button-text" />*/}
                <Button label="Ok, eu entendi" icon="pi pi-check" onClick={() => this.onHide(name)} autoFocus />
            </div>
        );
    }

    render() {
        return (
            <div className="dialog-demo">
                <div className="card">
                    <Dialog header="Sejam bem vindos" visible={this.state.displayBasic} style={{ width: '70vw', height: '200vh' }} footer={this.renderFooter('displayBasic')} onHide={() => this.onHide('displayBasic')}>
                        <h1>Atenção!!! O novo portal está em modo de produção, isso quer dizer que todos
                            os dados transitados são reais e as vendas serão computadas.</h1>
                    </Dialog>
                </div>
            </div>
        )
    }
}


